"use client";

import { SettingsRow, SettingsSection } from "@commerce/components/page";
import { useWorkspace } from "@commerce/components/use-workspace";
import { authClient } from "@repo/auth/client";
import { useOrganizationListQuery } from "@saas/organizations/lib/api";
import { TypeToConfirmDialog } from "@saas/settings/components/TypeToConfirmDialog";
import { Button } from "@ui/components/button";
import { toast } from "@ui/components/toast";
import { useState } from "react";
import { useActiveOrganization } from "../hooks/use-active-organization";

/** Owners and admins only; shown at the bottom of General. */
export function DeleteOrganizationForm() {
	const { organization } = useWorkspace();
	const { setActiveOrganization } = useActiveOrganization();
	const { refetch: reloadOrganizations } = useOrganizationListQuery();
	const [open, setOpen] = useState(false);

	if (!organization) {
		return null;
	}

	return (
		<SettingsSection
			tone="danger"
			title="Delete this retailer"
			description="Its catalog, agent, conversations and API keys go, and the shopper chat stops working."
		>
			<SettingsRow
				label={`Delete ${organization.name}`}
				description="No undo, no backup."
			>
				<Button variant="destructive" onClick={() => setOpen(true)}>
					Delete retailer
				</Button>
			</SettingsRow>
			<TypeToConfirmDialog
				open={open}
				onOpenChange={setOpen}
				title={`Delete ${organization.name}?`}
				description="Shoppers can no longer reach its agent."
				confirmText={organization.name}
				actionLabel="Delete retailer"
				onConfirm={async () => {
					const { error } = await authClient.organization.delete({
						organizationId: organization.id,
					});
					if (error) {
						throw error;
					}
					toast.add({
						type: "success",
						title: `${organization.name} was deleted`,
					});
					await setActiveOrganization(null);
					await reloadOrganizations();
					window.location.href = "/app";
				}}
			/>
		</SettingsSection>
	);
}
